import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Heading from '@totallymoney/ui/components/Heading'
import LinkButton from '@totallymoney/ui/components/LinkButton'
import Text from '@totallymoney/ui/components/Text'

import { CreditCardAlternativeProduct } from '@appTypes/EligibilityApi.interface'

import CardImage from '@components/CardImage'

import ProsAndConsList from './components/ProsAndConsList'

interface AlternativeProductsTableItemProps {
    applyHref: string
    isPortraitImage: boolean
    item: CreditCardAlternativeProduct
    onApplyPress: (item: CreditCardAlternativeProduct) => void
}

const AlternativeProductsTableItem = ({
    item,
    isPortraitImage,
    applyHref,
    onApplyPress,
}: AlternativeProductsTableItemProps) => {
    return (
        <Box
            px={['space30', 'space50']}
            py="space30"
            backgroundColor="white"
            borderRadius="borderRadius10"
            boxShadow="0px 2px 4px rgba(0, 0, 0, 0.05)"
            display="grid"
            gridGap="space30"
            gridTemplateColumns="repeat(12, 1fr)"
            data-testid={`alternative-product-item-${item.productCode}`}
        >
            <Box gridColumn="1/13">
                <Heading variant="60">{item.header}</Heading>
            </Box>
            <Flex
                gridColumn={['1/13', '1/6']}
                justifyContent={['center', 'flex-start']}
                width={[88, 139]}
            >
                <CardImage
                    cmsImageUrl={item.imageUrl}
                    name={item.header}
                    isPortraitImage={isPortraitImage}
                />
            </Flex>
            <Box
                pt={[0, 'space20']}
                gridColumn="1/13"
                display="grid"
                gridGap="space30"
                gridTemplateColumns={['1fr', '1fr 1fr']}
            >
                {item.pros != null && item.pros.length > 0 ? (
                    <Box>
                        <ProsAndConsList
                            listHeading="Great for"
                            list={item.pros}
                        />
                    </Box>
                ) : null}
                {item.cons != null && item.cons.length > 0 ? (
                    <Box>
                        <ProsAndConsList
                            listHeading="Beware of"
                            list={item.cons}
                        />
                    </Box>
                ) : null}
            </Box>
            <Flex
                gridColumn={['1/13', '6/13']}
                gridRow={['unset', '2']}
                alignItems="flex-end"
                justifyContent="flex-end"
            >
                <LinkButton
                    href={applyHref}
                    variant="primary"
                    text={isPortraitImage ? 'More details' : 'Apply now'}
                    onClick={evt => {
                        evt.preventDefault()
                        onApplyPress(item)
                    }}
                />
            </Flex>
            {item.representativeExample != null ? (
                <Box gridColumn="1/13">
                    <Box
                        height={1}
                        backgroundColor="productNeutral140"
                        mb="space20"
                    />
                    <Box mx="space30">
                        <Text color="light">{item.representativeExample}</Text>
                    </Box>
                </Box>
            ) : null}
        </Box>
    )
}

export default AlternativeProductsTableItem
